import { CloseCircleOutlined } from '@ant-design/icons'
import { Modal } from 'antd'
import React, { useEffect, useState } from 'react'
import ldBg from "../../assets/LD-bg.png"
import badge1 from "../../assets/Medalld-badge-1.png"
import badge2 from "../../assets/Medalld-badge-2.png"
import badge3 from "../../assets/Medalld-badges -3.png"
import badge4 from "../../assets/Medalld-badges-all.png"
import ProfileIc from "../../assets/Profile Icon.png"

const CardDesign = ({ index, item }) => {
    const badges = [badge1, badge2, badge3, badge4]
    return (
        <div className='leader-card-1' style={{}}>
            <div className='cd-layout-1' style={{}}>
                <div className='cd-no'>
                    {index + 1}
                </div>
                <div className='cd-profile-ic' style={{}}><img className='full-img' src={ProfileIc} /></div>
                <div className='r-c-fs' style={{ width: "100%" }}>{item?.User?.name ? item?.User?.name : "Unknown User"}</div>
            </div>
            <div className='r-c-sb cd-layout-2 ' style={{}}>
                <div>{item?.totalScoreSum} {item?.totalScoreSum == 1 || item?.totalScoreSum == "1" ? "point" : "points"}</div>
                <div className='p-5 cd-badges ' style={{}}><img className='full-img' src={index == 0 || index == 1 || index == 2 ? badges[index] : badge4} /> </div>
            </div>
        </div>
    )
}

function LeaderBoardModal({ isLeaderBoardOpen, setLeaderBoardOpen, subOrgId, leaderBoardData }) {

    console.log("subOrgId", subOrgId, leaderBoardData)
    const dummyArray = [
        {
            "UserId": 34,
            "totalScoreSum": "543",
            "User": {
                "name": "Rajat Bhat",
                "username": "rajat",
                "email": "bhatrajat95@gmail.com",
                "phone": null,
                "city": "Pune"
            }
        },
        {
            "UserId": 32,
            "totalScoreSum": "418",
            "User": {
                "name": "RG",
                "username": "RG",
                "email": "rohan@thegamificationcompany.com",
                "phone": null,
                "city": "Bombay"
            }
        },
        {
            "UserId": 14,
            "totalScoreSum": "408",
            "User": {
                "name": "test-1",
                "username": "test-1",
                "email": null,
                "phone": "+917780665663",
                "city": "banglore"
            }
        },
        {
            "UserId": 17,
            "totalScoreSum": "329",
            "User": {
                "name": "Rohan",
                "username": "Rohan",
                "email": null,
                "phone": "+919405162480",
                "city": "Demo"
            }
        },
        {
            "UserId": 25,
            "totalScoreSum": "298",
            "User": {
                "name": "Vaishnavi",
                "username": "Vaishnavi",
                "email": null,
                "phone": "+917780665660",
                "city": "Pune"
            }
        },
        {
            "UserId": 38,
            "totalScoreSum": "220",
            "User": {
                "name": "test",
                "username": "test4",
                "email": "anilkumarg2224@gmail.com",
                "phone": null,
                "city": "bnglr"
            }
        },
        {
            "UserId": 11,
            "totalScoreSum": "203",
            "User": {
                "name": "12",
                "username": "12",
                "email": null,
                "phone": "+917780665663",
                "city": "gadwal"
            }
        },
        {
            "UserId": 21,
            "totalScoreSum": "181",
            "User": {
                "name": "Joel",
                "username": "Joel",
                "email": null,
                "phone": "+919405163052",
                "city": "Pune"
            }
        },
        {
            "UserId": 7,
            "totalScoreSum": "124",
            "User": {
                "name": "test",
                "username": "test",
                "email": "anilkumarg2224@gmail.com",
                "phone": null,
                "city": "gadwal"
            }
        },
        {
            "UserId": 22,
            "totalScoreSum": "110",
            "User": {
                "name": "Chetna",
                "username": "Chetna",
                "email": null,
                "phone": "+918856123456",
                "city": "Pune"
            }
        },
        {
            "UserId": 48,
            "totalScoreSum": "94",
            "User": {
                "name": "Testing Chetna",
                "username": "testingchetna",
                "email": "chetna@thegamificationcompany.com",
                "phone": null,
                "city": "Pune "
            }
        },
        {
            "UserId": 40,
            "totalScoreSum": "82",
            "User": {
                "name": "Rohan Ghodeswar",
                "username": "RohanG",
                "email": "ghodeswarr1993@gmail.com",
                "phone": null,
                "city": "Pusad"
            }
        },
        {
            "UserId": 52,
            "totalScoreSum": "79",
            "User": {
                "name": "RohitS",
                "username": "RohitS",
                "email": "rockingrony111@gmail.com",
                "phone": null,
                "city": "Pune"
            }
        },
        {
            "UserId": 53,
            "totalScoreSum": "77",
            "User": {
                "name": "Carl",
                "username": "Carl",
                "email": "carlambrose07@gmail.com",
                "phone": null,
                "city": "Mumbai@123"
            }
        },
        {
            "UserId": 16,
            "totalScoreSum": "75",
            "User": {
                "name": "Rohan",
                "username": "RohanGhodeswar",
                "email": "rohanghodeswar111@gmail.com",
                "phone": null,
                "city": "Nagpur"
            }
        },
        {
            "UserId": 18,
            "totalScoreSum": "74",
            "User": {
                "name": "Mukta",
                "username": "Mukta3",
                "email": null,
                "phone": "+919890324470",
                "city": "Pune"
            }
        },
        {
            "UserId": 41,
            "totalScoreSum": "57",
            "User": {
                "name": "Testing Muktaa",
                "username": "Testing Muktaa",
                "email": "mukta@thegamificationcompany.com",
                "phone": null,
                "city": "Pune"
            }
        },
        {
            "UserId": 50,
            "totalScoreSum": "44",
            "User": {
                "name": "Testing Samdarsh",
                "username": "Testing Samdarsh",
                "email": "samdarsh@thegamificationcompany.com",
                "phone": null,
                "city": "Pune"
            }
        },
        {
            "UserId": 20,
            "totalScoreSum": "42",
            "User": {
                "name": "Samdarsh",
                "username": "Samdarsh",
                "email": null,
                "phone": "+917786265663",
                "city": "Pune"
            }
        },
        {
            "UserId": 46,
            "totalScoreSum": "41",
            "User": {
                "name": "Testingcarl",
                "username": "Testingcarl",
                "email": "Carl@thegamificationcompany.com",
                "phone": null,
                "city": "Rrr"
            }
        },
        {
            "UserId": 23,
            "totalScoreSum": "40",
            "User": {
                "name": "Prachi",
                "username": "Prachi",
                "email": null,
                "phone": "+919922123456",
                "city": "Pune"
            }
        },
        {
            "UserId": 37,
            "totalScoreSum": "40",
            "User": {
                "name": "Shubham Karad",
                "username": "Shubham1213",
                "email": null,
                "phone": "+917397847916",
                "city": "Tgc123"
            }
        },
        {
            "UserId": 24,
            "totalScoreSum": "36",
            "User": {
                "name": "Rutuja",
                "username": "Rutuja",
                "email": null,
                "phone": "+919800001234",
                "city": "Pune"
            }
        },
        {
            "UserId": 57,
            "totalScoreSum": "33",
            "User": {
                "name": "Takshak",
                "username": "Manhunt",
                "email": "takshakkarmarkar2@gmail.com",
                "phone": null,
                "city": "Pune"
            }
        },
        {
            "UserId": 30,
            "totalScoreSum": "32",
            "User": {
                "name": "Sonal Seth",
                "username": "Sonal08",
                "email": "sonal@thegamificationcompany.com",
                "phone": null,
                "city": "Pune"
            }
        },
        {
            "UserId": 39,
            "totalScoreSum": "29",
            "User": {
                "name": "Sunitha ",
                "username": "Harish",
                "email": "sunitha.harish@ikshealth.com",
                "phone": null,
                "city": "MUMBAI"
            }
        },
        {
            "UserId": 49,
            "totalScoreSum": "28",
            "User": {
                "name": "Testingprashant",
                "username": "Testingprashant",
                "email": "prashants@thegamificationcompany.com",
                "phone": null,
                "city": "Pune"
            }
        },
        {
            "UserId": 42,
            "totalScoreSum": "24",
            "User": {
                "name": "Snehal",
                "username": "Testing Snehal",
                "email": "snehalp@thegamificationcompany.com",
                "phone": null,
                "city": "Pune"
            }
        },
        {
            "UserId": 43,
            "totalScoreSum": "21",
            "User": {
                "name": "Megha khanna",
                "username": "Testing Megha",
                "email": "megha@thegamificationcompany.com",
                "phone": null,
                "city": "Megha123#"
            }
        },
        {
            "UserId": 51,
            "totalScoreSum": "6",
            "User": {
                "name": "Rajat",
                "username": "rajatbhat",
                "email": "rajat@thegamificationcompany.com",
                "phone": null,
                "city": "Pune"
            }
        }
    ]

    return (
        <div>
            <Modal
                open={isLeaderBoardOpen}
                onCancel={() => setLeaderBoardOpen(false)}
                footer={null}
                closeIcon={false}
                className='r-c-c token-model'
                maskClosable={false}
                style={{ overflow: 'hidden !important', top: "0px" }}
                bodyStyle={{ height: "100vh", width: "90vw", overflow: 'hidden !important', }}
            >
                <div className='r-c-c-c need-parent-div'>
                    <div className='need-div-1'>{"Leaderboard"}</div>
                    <div className='need-div-2' onClick={() => setLeaderBoardOpen(false)}><CloseCircleOutlined /></div>
                    <div className='need-div-3' ><img src={ldBg} className='full-img' />
                    </div>
                    <div className=' cd-parent scroll-bar-universal' style={{}}>
                        {leaderBoardData?.map((i, index) => <CardDesign item={i} index={index} />)}
                    </div>

                </div>
            </Modal>
        </div>
    )
}

export default LeaderBoardModal
